export const getParentTd = (target: HTMLElement) => {
  let element = target;

  while (!element.matches("td[data-index]")) {
    element = element.parentElement!;
  }

  return element;
};